<style lang="scss" scoped>
@import "./subject";

.my {

  &:not(&--selected) {
    background: $color-bg-base;
    color: $color-muted;
  }

  &--selected {
    background: #fff5aa;
  }

  &--fixed {
    background: #fff;
  }

  @include my-context-style($root-suffix: __body);

  &__select-type {
    width: $select-type-width;

    select {
      &[disabled] {
        opacity: .5;
      }
    }

    .dn-manabi & {
      display: none!important;
    }
  }

  &__action {

    &__btn {
      min-width: 8em;
    }
  }
}

// .my__children {}
.my__child {
  border-top: solid 1px $color-divider;
}
.manabi-subject {
  .my {
    &__action {
      &__btn {
        min-width: 0;
      }
    }
  }
}
</style>



<template>
  <div class="my" :class="[classes, {'manabi-subject' : $store.getters['config/isManabi']}]" :id="`subject-${id}`">
    <template v-if="$store.getters['config/isManabi']">
      <dl class="my__body">
        <dt class="my__name">
          <dn-chk-btn
            v-model="selected"
          >{{name}}</dn-chk-btn>
        </dt>
        <dd class="my__detail">
          <div class="my__detail__column my__select-type">
            <select
              v-model="type"
              :disabled="!selected"
            >
              <option value="selfcheck">解答入力</option>
              <option value="direct">点数入力</option>
            </select>
          </div>
          <form class="my__detail__column my__input-score" @submit.prevent="storeDirectScore">
            <input
              v-model="inputDirectScore"
              v-number-range
              type="tel"
              number
              min="0"
              :max="max"
              :disabled="!selected"
            >
            点
          </form>
          <div class="my__detail__column my__action">
            <!--
            <dn-btn
              class="my__action__btn"
              v-if="isSelfCheck"
              :accent="!fixed"
              :plain="fixed"
              sm
              :disabled="!selected"
              :href="`./${id}.html`"
              @click.prevent="onClickSubjectSelfCheck"
              :key="`my__action__btn--${type}`"
            >
              <dn-icon icon="pen" :class="fixed || !selected ? 'is-disabled' : 'is-white'" />
              <span class="mr10">{{fixed ? '採点しなおす' : '採点'}}</span>
            </dn-btn>
            -->
            <dn-btn
              class="my__action__btn"
              accent
              sm
              :disabled="!selected || !anyDirectScoreIsUpdated"
              @click="storeDirectScore"
              :key="`my__action__btn--${type}`"
            >
              登録
            </dn-btn>

            <dn-btn
              class="my__action__btn"
              sm
              :disabled="!selected || !hasAnyScore"
              @click="clearDirectScore"
              :key="`my__action__btn--${type}--clear`"
            >
              削除
            </dn-btn>
          </div>
          <div class="my__detail__column my__score">
            <span
              class="my__score__value"
              :class="{
                'my__score__value--has': hasScore,
                'my__score__value--active': hasScore && selected,
              }"
            >{{hasScore ? score : '---'}}</span>/<span class="my__score__max">{{max}}点</span>
          </div>
        </dd>
      </dl>
      <div class="my__children" v-if="children.length">
        <my-child-subject
          v-for="child in children"
          :key="child.id"
          class="my__child"
          :id="child.id"
          :type="type"
          :selected="selected"
          :fixed="fixed"
          :direct-score-bucket="directScoreBucket"
          @updateDirectScoreBucket="directScoreBucket = $event"
          :directscore-changes-bucket="directScoreChangesBucket"
          @updateDirectScoreChangesBucket="directScoreChangesBucket = $event"
          @submit-directscore="storeDirectScore"
          ref="child-subject"
        />
      </div>
    </template>
    <template v-else>
    <dl class="my__body">
      <dt class="my__name">
        <dn-chk-btn
          v-model="selected"
        >{{name}}</dn-chk-btn>
      </dt>
      <dd class="my__detail">
        <div class="my__detail__column my__select-type">
          <select
            v-model="type"
            :disabled="!selected"
          >
            <option value="selfcheck">解答入力</option>
            <option value="direct">点数入力</option>
          </select>
        </div>
        <form class="my__detail__column my__input-score" v-if="isDirect" @submit.prevent="storeDirectScore">
          <input
            v-model="inputDirectScore"
            v-number-range
            type="tel"
            number
            min="0"
            :max="max"
            :disabled="!selected"
          >
          点
        </form>
        <div class="my__detail__column my__action">
          <dn-btn
            class="my__action__btn"
            v-if="isSelfCheck"
            :accent="!fixed"
            :plain="fixed"
            sm
            :disabled="!selected"
            :href="`./${id}.html`"
            @click.prevent="onClickSubjectSelfCheck"
            :key="`my__action__btn--${type}`"
          >
            <dn-icon icon="pen" :class="fixed || !selected ? 'is-disabled' : 'is-white'" />
            <span class="mr10">{{fixed ? '採点しなおす' : '採点'}}</span>
          </dn-btn>

          <dn-btn
            class="my__action__btn"
            v-if="isDirect"
            accent
            sm
            :disabled="!selected || !anyDirectScoreIsUpdated"
            @click="storeDirectScore"
            :key="`my__action__btn--${type}`"
          >
            登録
          </dn-btn>

          <dn-btn
            class="my__action__btn"
            v-if="isDirect"
            sm
            :disabled="!selected || !hasAnyScore"
            @click="clearDirectScore"
            :key="`my__action__btn--${type}--clear`"
          >
            クリア
          </dn-btn>
        </div>
        <div class="my__detail__column my__score">
          <span
            class="my__score__value"
            :class="{
              'my__score__value--has': hasScore,
              'my__score__value--active': hasScore && selected,
            }"
          >{{hasScore ? score + '点' : '---'}}</span>
          <span class="my__score__separator">/</span>
          <span class="my__score__max">{{max}}点</span>
        </div>
      </dd>
    </dl>
    <div class="my__children" v-if="children.length">
      <my-child-subject
        v-for="child in children"
        :key="child.id"
        class="my__child"
        :id="child.id"
        :type="type"
        :selected="selected"
        :fixed="fixed"
        :direct-score-bucket="directScoreBucket"
        @updateDirectScoreBucket="directScoreBucket = $event"
        :directscore-changes-bucket="directScoreChangesBucket"
        @updateDirectScoreChangesBucket="directScoreChangesBucket = $event"
        @submit-directscore="storeDirectScore"
        ref="child-subject"
      />
    </div>
    </template>
  </div>
</template>



<script>
import MyChildSubject from './ChildSubject';


export default {

  components: {
    MyChildSubject,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  inject: ['resetCaliculateState'],

  data() {
    return {
      innerDirectScore: null,
      directScoreBucket: {},
      directScoreChangesBucket: [],
      innerState: 'pending',
    }
  },

  computed: {
    classes() {
      return {
        my: true,
        [`my--${this.type}`]: true,
        'my--selected': this.selected,
        'my--fixed': this.fixed,
      }
    },

    data() { return this.$store.getters['selfcheck/subjectOrChildById'](this.id) },
    name() { return this.data.name },
    max() { return this.data.max },
    children() { return this.data.children },

    inputDirectScore: {
      get() { return this.innerDirectScore },
      set(val) {
        if (val === '' || val === null || val === undefined) {
          val = null;
        } else {
          val = parseFloat(val);
        }
        this.innerDirectScore = val;
      },
    },

    history() { return this.$store.getters['selfcheck/subjectHistory'](this.id) },

    type: {
      get() { return this.history.type },
      async set(val) {
        await this.dispatchHistory({type: val});
        this.resetCaliculateState && this.resetCaliculateState();
      },
    },
    selected: {
      get() { return this.history.selected },
      async set(val) {
        const selectedIds = this.$store.getters['selfcheck/selectedSubjectIds'].slice();
        if (val) {
          if (!selectedIds.includes(this.id)) selectedIds.push(this.id);
        } else {
          const index = selectedIds.indexOf(this.id);
          if (index !== -1) selectedIds.splice(index, 1);
        }
        const errors = this.$store.getters['selfcheck/subjectSelectionErrors'](selectedIds);
        if (errors) {
          dn.$alert(errors.map(error => `・${error}`).join('\n'));
          return false;
        }

        if (this.hasChild) {
          for (let child of this.children) {
            this.dispatchHistory({selected: val}, child.id);
          }
        }
        await this.dispatchHistory({selected: val});
        this.resetCaliculateState && this.resetCaliculateState();
      },
    },
    state() { return this.history.state },
    fixed() { return this.history.fixed },
    hasScore() { return this.history.hasScore },
    isDirect() { return this.history.isDirect },
    isSelfCheck() { return this.history.isSelfCheck },
    score() { return this.history.score },
    selfcheckScore() { return this.history.selfcheckScore },
    directScore() { return this.history.directScore },
    hasAnyScore() {
      if (typeof this.inputDirectScore === 'number') return true;
      for (let id in this.directScoreBucket) {
        if (typeof this.directScoreBucket[id] === 'number') return true;
      }
      return false;
    },
    directScoreIsUpdated() { return this.inputDirectScore !== this.directScore },
    anyDirectScoreIsUpdated() { return this.directScoreChangesBucket.length > 0 },
    hasChild() { return this.children.length > 0 },
  },

  watch: {
    state(val) {
      this.$emit('change-state', val);
      this.resetCaliculateState && this.resetCaliculateState();
    },
    innerDirectScore(val) {
      this.directScoreBucket[this.id] = val;
      this.resetCaliculateState && this.resetCaliculateState();
    },

    directScore(val) {
      if (val !== this.innerDirectScore) this.innerDirectScore = val;
    },

    directScoreIsUpdated(val) {
      const bucket = this.directScoreChangesBucket;
      if (val) {
        if (!bucket.includes(this.id)) bucket.push(this.id);
      } else {
        const index = bucket.indexOf(this.id);
        if (index !== -1) bucket.splice(index, 1);
      }
    },
  },

  methods: {
    dispatchHistory(data, id = this.id) {
      return this.$store.dispatch('selfcheck/setSubjectHistory', {id, data});
    },

    async onClickSubjectSelfCheck() {
      await this.dispatchHistory({selfCheckIsFinished: false});
      location.href = `./${this.id}.html`;
    },

    storeDirectScore() {
      if (!this.anyDirectScoreIsUpdated) return;

      const onInvalid = (message = `${this.name}の入力に誤りがあります。`) => {
        dn.$alert(message);
      }

      const $children = this.$refs['child-subject'] || [];

      if (this.hasAnyScore) {

        // >>> いずれかの入力があるのでチェック
        const childrenDirectScores = $children.map(vm => vm.inputDirectScore);
        const allDirectScore = [this.inputDirectScore, ...childrenDirectScores];

        // 最初に全数値が整数かつ、マイナスじゃないかのチェック
        for (let score of allDirectScore) {
          if (score !== null && Math.abs(Math.round(score)) !== score) {
            return onInvalid();
            break;
          }
        }

        // 子科目を保有している場合、子科目の得点の合計が自分の科目点数と一致しているかチェック
        if (this.hasChild) {
          const childrenTotal = childrenDirectScores.reduce((a, b) => (a + b));
          if (this.inputDirectScore !== childrenTotal) {
            return onInvalid(`${$children.map(vm => `「${vm.name}」`).join('')}の得点を確認してください。`);
          }
        }
      }

      // 全部OKなので全部ストアする
      const $allVms = [this, ...$children];
      for (let vm of $allVms) {
        this.dispatchHistory({directScore: vm.inputDirectScore}, vm.id);
      }
      this.$dn.blurActiveElement();
    },

    async clearDirectScore() {
      if (!await dn.$confirm('点数をクリアしてよろしいですか？')) return;
      this.$dn.blurActiveElement();

      const $children = this.$refs['child-subject'] || [];
      const $allVms = [this, ...$children];
      for (let vm of $allVms) {
        await this.dispatchHistory({directScore: null}, vm.id);
        vm.restoreDirectScore();
      }
    },

    restoreDirectScore() {
      this.inputDirectScore = this.history.directScore;
    },
  },

  created() {
    this.restoreDirectScore();
  },
}
</script>



// WEBPACK FOOTER //
// Subject.vue?5f718bbc